export default __webpack_public_path__ + "static/media/evelyn.f4874aa5.webp";